import { render, staticRenderFns } from "./message.html?vue&type=template&id=64fd0e48&"
import script from "./message.js?vue&type=script&lang=js&"
export * from "./message.js?vue&type=script&lang=js&"
import style0 from "./message.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports